<div class="panneau-menu-mois__container">
	<div class="menu-facture-preparee">
		<di-separateur-date date="EN ATTENTE DE FACTURATION"></di-separateur-date>
		<di-btn-facture-preparee (click)="onFacturesPrepareesSelected()" [invoiceCount]="nbPreparedInvoice" [selected]="showPreparedInvoice"></di-btn-facture-preparee>
	</div>
	<di-menu-mois [onMonthSelected]="onMonthSelected" [monthSelected]="!showPreparedInvoice"></di-menu-mois>
</div>
